import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export const FAQAccordion = ({ faqs, testid = "faq-accordion" }) => (
  <Accordion type="single" collapsible className="w-full" data-testid={testid}>
    {faqs.map((faq, i) => (
      <AccordionItem key={i} value={`faq-${i}`} className="border-b hairline">
        <AccordionTrigger
          data-testid={`faq-question-${i}`}
          className="text-left text-base sm:text-lg font-medium text-ink hover:text-terracotta py-5 hover:no-underline"
        >
          {faq.q}
        </AccordionTrigger>
        <AccordionContent className="text-slate-600 leading-relaxed pb-5 text-[15px]">
          {faq.a}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
